<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <CustomSelect name="event" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option data-component="Empty" value="Survival">Дожитие до окончания срока страхования</option>
      <option data-component="DeathSelect" value="LeavingLife">Уход из жизни</option>
    </CustomSelect>
  </div>

  <component :is="premierInvestComponent"></component>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoInsurer/>
</template>

<script>
import ContractInfoInsurer from "@/components/insurances/shared/ContractInfoInsurer";
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import DeathSelect from "@/components/insurances/PremierInvest/childs/DeathSelect";
import Empty from "@/components/utils/Empty";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "PremierInvest",
  components: {Empty, CustomSelect, ContractInfoInsurer, DeathSelect},
  methods: {
    // onEventSelectInitialize(event){
    //   this.$store.commit(mns.SET_EVENT, event.getValue().value);
    // },
    // onEventSelectItemSelected(event){
    //   this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
    // },
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_PREMIER_INVEST_COMPONENT, event.getValue().customProperties.component);
    },
    onEventSelectItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_PREMIER_INVEST_COMPONENT, choice.customProperties.component);
    },
  },
  computed: {
    ...mapGetters(['premierInvestComponent']),
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>

</style>